import { ManikEntityFE } from '../manik-library/ManikEntityFE';
import { ManikEntityService } from '../manik-library/ManikEntityService';
import { Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

declare const $: any;
declare interface IDateObject {
  Date: Date;
  DateIndex: number;
}

export class NovaBookingHandler extends ManikEntityFE {

  public PredefinedResourceTypeList: any[] = [];
  public DayArray: IDateObject[] = [];
  public Index: number;
  public SiteMetaData: any = JSON.parse(sessionStorage.getItem("SiteMetaData"));

  populateControls(): void { }
  refreshDataGrid(param: any): void { }

  constructor(public _manikEntityService: ManikEntityService, @Inject(DOCUMENT) public document) {
    super(document);
    this.CreateDayArray(new Date(), 0);
  }

  private DoesBookingLocalStoreExist(BizHandle: string): boolean {
    let MetaData = localStorage.getItem(BizHandle + "_UserContext");
    if (MetaData) return true;
    return false;
  }

  public PopulateOnlineBookingStore(BizHandle: string) {
    //TO-DO: Check metadata version using an ultra quick call
    this.MetaData_Download(BizHandle);
  }

  public MetaData_Download(BizHandle: string) {
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null, this.prepareAPIRequestHeaders2("BOOKING", "BOOKING.META.DATA", BizHandle, this.SiteMetaData.PC))
      .subscribe(data => {
        if (data) {
          let resp: any = data.ManikJSon[0];
          resp.JSon1.forEach(item => {
            if (!localStorage.getItem(BizHandle + '_' + item.Entity))
              localStorage.setItem(BizHandle + "_" + item.Entity, JSON.stringify(resp["JSon" + item.EntityIndex]));
          });
          return true;
        }
        return false;
      },
        error => {
          //this.showNotification('bottom', 'right', 'danger', 'Server error!')
        });
  }

  SubmitBookingRequest(userContext) {
    
    let body: any = {};
    body = userContext;
    //body['BookableResourceID'] = userContext['BookableResourceID'];
    //body['BuyerHandle'] = userContext['BuyerHandle'];
    //body['ServiceDate'] = userContext['ServiceDate'];
    //body['TimeSlotID'] = userContext['TimeSlotID'];
    console.log(body);
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", JSON.stringify({ "items": [body] }), this.prepareManageHeaders2("A", "BUSINESS.BOOKINGS", "BOOKING", this.SiteMetaData.PC))
      .subscribe(data => {
        let resp: any = data;
        alert('Request has been submitted!')
      });
  }

  DrawSupportingEffect(Type) {
    switch (Type) {
      case 'NONE': break;
      case 'CAL': this.DrawCalendar(); break;
      default: break;
    }
  }



  DrawCalendar() {
    let calendarTemplate = this.getOnDemandDivs().find(item => { return item.id == "odBOOK-CALENDAR" }).html;
    let headerHTML = calendarTemplate.split('~DELIMITER~')[0];
    headerHTML = headerHTML.replace('<maniksubeffect>', '');
    calendarTemplate = calendarTemplate.match("<maniksubeffect>(.*)</maniksubeffect>")[1];
    let targetControl = this.getOnDemandDivs().find(item => { return item.id == 'odBOOK-CALENDAR' }).targetcontrol;
    let dateHTML = calendarTemplate.split('~DELIMITER~')[1];
    let shiftHTML = calendarTemplate.split('~DELIMITER~')[2];
    let slotHTML = calendarTemplate.split('~DELIMITER~')[3];
    let dHtml = '';
    console.log(this.DayArray, this.Index);
    this.changeDateValue();
    for (let i = 0; i < this.DayArray.length; i++) {
      dHtml += dateHTML;
      let dowid = 100000 + ((this.DayArray[i].Date.getDay() - 1) > 0 ? (this.DayArray[i].Date.getDay() - 1) : (this.DayArray[i].Date.getDay() + 6));
      dHtml = dHtml.replace('#DAYINDEX#', this.DayArray[i].DateIndex.toString());
      dHtml = dHtml.replace('#DOWID#', dowid.toString());
      dHtml = dHtml.replace('#DAYTEXT#', this.getDatePrefix(this.DayArray[i].Date) + this.DayArray[i].Date.toLocaleDateString());
    }
    let shifts = JSON.parse(localStorage.getItem(this.getBizHandle() + '_' + "ResourceShifts"));
    shifts = shifts.filter(item => {
      return item.PredefinedResourceTypeID.toString() == this.GetUserContext()['ResourceTypeID'] && (item.DOWID == (100000 +
        (this.DayArray[this.Index].Date.getDay() - 1 >= 0 ? this.DayArray[this.Index].Date.getDay() - 1 : this.DayArray[this.Index].Date.getDay() + 6)));
    });
    let shHtml = '';
    for (let i = 0; i < shifts.length; i++) {
      shHtml += shiftHTML;
      shHtml = shHtml.replace('#SHIFTID#', shifts[i].MasterShiftID);
      shHtml = shHtml.replace('#SHIFTEXT#', shifts[i].ShiftName);
      let slots = JSON.parse(localStorage.getItem(this.getBizHandle() + '_' + "ResourcesSlots"));
      slots = slots.filter(item => {
        return item.ResourceShiftID.toString() == shifts[i].ResourceShiftID;
      });
      let slHtml = '';
      for (let j = 0; j < slots.length; j++) {
        slHtml += slotHTML;
        slHtml = slHtml.replace('#SLOTID#', slots[j].StartTimeID + '_' + slots[j].EndTimeID);
        slHtml = slHtml.replace('#SLOTTEXT#', slots[j].TimeSlot);
      }
      shHtml = shHtml.replace('#SLOTSHOLDER#', slHtml);
    }
    headerHTML = headerHTML.replace('#DATEHOLDER#', dHtml);
    headerHTML = headerHTML.replace('#SHIFTSHOLDER#', shHtml);

    if (targetControl === "manikPopup") {
      $("#iPopupBody").empty();
      $("#iPopupBody").html(headerHTML);
      setTimeout(() => {
        $("#myModal").find(".modal-dialog").attr('style', $("#pluginBOOK-CALENDAR").attr('popupstyle'));
        this.PaintActiveDate();
      }, 10);
      $("#ONDEMANDPLUGINS").show();
      $("#myModal").modal();
    }
    else if (targetControl === 'bookWorkspace') {
      $("#iManikCalendar").empty();
      $("#iManikCalendar").html(headerHTML);
      setTimeout(() => {
        this.PaintActiveDate();
      }, 10);
    }

  }

  changeDateValue() {
    this.document.getElementById("dtBookDate").valueAsDate = this.DayArray[this.Index].Date;
    $('#dtBookDate').change();
  }

  PaintActiveSlot(id) {
    let slots = document.getElementsByClassName('cScheduleTimeSlot');
    for (let i = 0; i < slots.length; i++) {
      let x;
      let attributes = slots[i].attributes;
      for (let i = 0; i < attributes.length; i++) {
        if (attributes[i].nodeName == 'dataid') {
          x = attributes[i].nodeValue;
        }
      }
      if (x == id) {
        slots[i].classList.add('cActiveBookingSlot');
      }
      else {
        slots[i].classList.remove('cActiveBookingSlot');
      }
    }
  }


  PaintActiveDate() {
    let dates = document.getElementsByClassName('cScheduleSlot-slider-item');
    for (let i = 0; i < this.DayArray.length; i++) {
      dates[i].classList.remove('cActiveBookingDate');
    }
    dates[this.Index].classList.add('cActiveBookingDate');
  }

  DrawSlotsOnly() {
    $('.cBookingSchedule .slides').empty();
    console.log(this.DayArray, this.Index);
    let shifts = JSON.parse(localStorage.getItem(this.getBizHandle() + '_' + "ResourceShifts"));
    shifts = shifts.filter(item => {
      return item.PredefinedResourceTypeID.toString() == this.GetUserContext()['ResourceTypeID'] && (item.DOWID == (100000 +
        (this.DayArray[this.Index].Date.getDay() - 1 >= 0 ? this.DayArray[this.Index].Date.getDay() - 1 : this.DayArray[this.Index].Date.getDay() + 6)));
    });
    let shHtml = '';
    for (let i = 0; i < shifts.length; i++) {
      let calendarTemplate = this.getOnDemandDivs().find(item => { return item.id == "odBOOK-CALENDAR" }).html;
      let headerHTML = calendarTemplate.split('~DELIMITER~')[0];
      headerHTML = headerHTML.replace('<maniksubeffect>', '');
      calendarTemplate = calendarTemplate.match("<maniksubeffect>(.*)</maniksubeffect>")[1];
      let shiftHTML = calendarTemplate.split('~DELIMITER~')[2];
      let slotHTML = calendarTemplate.split('~DELIMITER~')[3];
      shHtml += shiftHTML;
      shHtml = shHtml.replace('#SHIFTID#', shifts[i].MasterShiftID);
      shHtml = shHtml.replace('#SHIFTEXT#', shifts[i].ShiftName);
      let slots = JSON.parse(localStorage.getItem(this.getBizHandle() + '_' + "ResourcesSlots"));
      slots = slots.filter(item => {
        return item.ResourceShiftID.toString() == shifts[i].ResourceShiftID;
      });
      let slHtml = '';
      for (let j = 0; j < slots.length; j++) {
        slHtml += slotHTML;
        slHtml = slHtml.replace('#SLOTID#', slots[j].StartTimeID + '_' + slots[j].EndTimeID);
        slHtml = slHtml.replace('#SLOTTEXT#', slots[j].TimeSlot);
      }
      shHtml = shHtml.replace('#SLOTSHOLDER#', slHtml);
    }
    $('.cBookingSchedule .slides').html(shHtml);
    this.PaintActiveDate();
  }

  removeDuplicates(myArr, prop) {
    return myArr.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
  }

  GetUserContext() {
    return JSON.parse(localStorage.getItem(this.getBizHandle() + '_' + 'UserContext'))[0];
  }

  getDatePrefix(date: Date) {
    let prefix = '';
    if (date.toLocaleDateString() == new Date().toLocaleDateString()) {
      prefix = 'Today, '
    }
    else {
      switch (date.getDay()) {
        case 0:
          prefix = 'Sun, '; break;
        case 1:
          prefix = 'Mon, '; break;
        case 2:
          prefix = 'Tue, '; break;
        case 3:
          prefix = 'Wed, '; break;
        case 4:
          prefix = 'Thu, '; break;
        case 5:
          prefix = 'Fri, '; break;
        case 6:
          prefix = 'Sat, '; break;
      }
    }
    return prefix;
  }

  getBizHandle() {
    return window['angularComponentRef'].zone.run(() => window['angularComponentRef'].component.BizHandle);
  }

  OnClickSlot(slot, shift) {
    this.PaintActiveSlot(slot);
    this.document.getElementById("ddShift").value = shift;
    $('#ddShift').change();
    setTimeout(() => {
      this.document.getElementById("ddSlot").value = slot;
      $('#ddSlot').change();
    }, 10);
  }

  CreateDayArray(startDate, selectIndex) {
    this.DayArray = [];
    for (let i = 0; i < 3; i++) {
      let sd = new Date(startDate);
      sd.setDate(sd.getDate() + i);
      let body: any = {};
      body['Date'] = sd;
      body['DateIndex'] = i;
      this.DayArray.push(body);
    }
    this.Index = selectIndex;
  }

  OnClickDate(index) {
    this.Index = index;
    this.changeDateValue();
    this.DrawSlotsOnly();
  }

  OnClickNext() {
    if (this.Index != 2) {
      this.Index++;
      this.changeDateValue();
      this.DrawSlotsOnly();
    }
    else {
      this.CreateDayArray(this.DayArray[this.Index].Date.setDate(this.DayArray[this.Index].Date.getDate() + 1), 0);
      this.DrawCalendar();
    }
  }



  OnClickPrevious() {
    if (this.Index != 0) {
      this.Index--;
      this.changeDateValue();
      this.DrawSlotsOnly();
    }
    else {
      if (this.getDateString(new Date()) == this.getDateString(this.DayArray[this.Index].Date)) {
        return;
      }
      this.CreateDayArray(this.DayArray[this.Index].Date.setDate(this.DayArray[this.Index].Date.getDate() - 3), 2);
      this.DrawCalendar();
    }
  }


  public getDateTimeString(date: any, timeS: any) {
    date = this.getManikDateString(date);
    var myDate = new Date(date);
    var d = myDate.getDate();
    var m = myDate.getMonth();
    m += 1;
    var y = myDate.getFullYear();
    date = (y + "-" + (m < 10 ? '0' + m : m) + "-" + (d < 10 ? '0' + d : d));

    var time = timeS.toUpperCase();
    var hours = Number(time.match(/^(\d+)/)[1]);
    var minutes = Number(time.match(/:(\d+)/)[1]);
    var AMPM = time.match(/\s(.*)$/)[1];
    if (AMPM == "PM" && hours < 12) hours = hours + 12;
    if (AMPM == "AM" && hours == 12) hours = hours - 12;
    var sHours = hours.toString();
    var sMinutes = minutes.toString();
    if (hours < 10) sHours = "0" + sHours;
    if (minutes < 10) sMinutes = "0" + sMinutes;
    return date + 'T' + sHours + ":" + sMinutes + ':00';
  }

  protected getManikDateString(date: any): string {
    let newDate: Date = new Date(date);
    return ((newDate.getMonth() + 1) + '-' + newDate.getDate() + '-' + newDate.getFullYear());
  }

  protected getDateString(date: any): string {
    let newDate: Date = new Date(date);
    var d = newDate.getDate();
    var m = newDate.getMonth();
    m += 1;
    var y = newDate.getFullYear();
    date = (y + "-" + (m < 10 ? '0' + m : m) + "-" + (d < 10 ? '0' + d : d));
    return date;
  }

  public getOnDemandDivs() {
    return window['angularComponentRef'].zone.run(() => window['angularComponentRef'].component.OnDemandDivArray);
  }

}
